(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lre-scroll-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-lre-scroll-top]');
    if (!button || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeScrollTarget = document.scrollingElement || document.documentElement;

    const updateVisibility = (event) => {
      const eventTarget =
        event?.target instanceof Element && typeof event.target.scrollTop === 'number'
          ? event.target
          : null;
      const eventScrollTop = eventTarget?.scrollTop || 0;
      if (eventTarget && eventScrollTop > 0) activeScrollTarget = eventTarget;
      const scrollTop = Math.max(
        window.scrollY || 0,
        document.scrollingElement?.scrollTop || 0,
        document.documentElement.scrollTop || 0,
        document.body.scrollTop || 0,
        eventScrollTop
      );
      const threshold = window.matchMedia('(max-width: 749px)').matches
        ? Math.min(280, window.innerHeight * 0.3)
        : 96;
      button.hidden = scrollTop < threshold;
    };

    button.addEventListener('click', () => {
      const behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
      const targets = [
        activeScrollTarget,
        document.scrollingElement,
        document.documentElement,
        document.body
      ].filter(Boolean);

      [...new Set(targets)].forEach((target) => {
        if (typeof target.scrollTo === 'function') {
          target.scrollTo({ top: 0, left: 0, behavior });
        } else if (typeof target.scrollTop === 'number') {
          target.scrollTop = 0;
        }
      });

      window.scrollTo({ top: 0, left: 0, behavior });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    document.addEventListener('scroll', updateVisibility, { passive: true, capture: true });
    window.addEventListener('resize', updateVisibility, { passive: true });

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(updateVisibility)
      : null;
    resizeObserver?.observe(document.documentElement);

    window.requestAnimationFrame(updateVisibility);
    window.setTimeout(updateVisibility, 250);
  })();
  } catch(e) { console.error(e); }
})();

})();
